import { useContext, useEffect } from "react";
import { AuthenticationContext } from "../providers/authentication/authentication.provider";
import { IRouteGuardProps } from "./route.interface";
import { Navigate, useLocation } from "react-router-dom";
import { routes } from "../router/routes";
import Loading from "../../components/Loading/Loading";
import { getCookies } from "../helpers/utils";
import { COOKIES } from "../constants";
import UserProvider from "../providers/user/user.provider";

function RouteGuard({ children }: IRouteGuardProps) {
    const { isAuthenticated, setIsAuthenticated, user, authTokens } = useContext(AuthenticationContext);
    const location = useLocation();

    useEffect(() => {
        const cookies = getCookies();

        if (cookies[COOKIES.REFRESH_TOKEN]) {
            setIsAuthenticated(true);
        } else if (!authTokens) {
            setIsAuthenticated(false);
        }
    }, [location, setIsAuthenticated, authTokens]);

    if (isAuthenticated === undefined || (isAuthenticated && !user)) return <Loading />;

    if (!isAuthenticated) return <Navigate to={routes.LOGIN.path} />;

    return (
        <UserProvider>
            {children}
        </UserProvider>
    );
}

export default RouteGuard;
